import Helpers from '@helpers';
import * as React from 'react';
import { OrderSummaryHelper, Prop, State } from './model';
import './styles.css';

const orderSummaryHelper: OrderSummaryHelper = {};
class OrderSummary extends React.Component<Prop, State> {
    constructor(props) {
        super(props);

        this.state = this.getInitialState();
    }

    public componentDidMount() {
        Helpers.LoadingHelper.showLoading();
        Helpers.ApiHelper.getOrderSummary().then(response => {
            this.setState({
                ...response
            });
        }).always(_ => {
            Helpers.LoadingHelper.hideLoading();
        });

        orderSummaryHelper.setDeliveryCost = this.setDeliveryCost;
        orderSummaryHelper.setOfficialInvoice = this.setOfficialInvoice;
        orderSummaryHelper.setCartTotal = this.setCartTotal;
        orderSummaryHelper.setErrors = this.setErrors;
        orderSummaryHelper.setVoucherDiscount = this.setVoucherDiscount;
        orderSummaryHelper.setInstallmentAmount = this.setInstallmentAmount;
    }

    public render() {
        const finalAmount = this.getFinamAmount();
        return (
            <div className='sticky-sidebar'>
                <div className='row no-gutters order-summary-block'>
                    <div className='order-summary-item'>
                        <span>
                            مبلغ کل
                        </span>
                        <span>
                            {Helpers.Utils.formatPrice(this.state.cartTotal)}
                        </span>
                    </div>

                    <div style={{ display: this.state.cartDiscount && this.state.cartDiscount > 0 ? 'flex' : 'none' }}
                        className='order-summary-item'>
                        <span>
                            سود شما از خرید
                        </span>
                        <span>
                            {Helpers.Utils.formatPrice(this.state.cartDiscount)}
                        </span>
                    </div>

                    <div style={{ display: this.state.voucherDiscount &&
                        this.state.voucherDiscount > 0 ? 'flex' : 'none' }}
                        className='order-summary-item'>
                        <span>
                            کد تخفیف
                        </span>
                        <span>
                            {Helpers.Utils.formatPrice(this.state.voucherDiscount)}
                        </span>
                    </div>

                    <div style={{
                        display: this.state.isOfficialInvoice? 'flex' : 'none'
                        }}
                        className='order-summary-item'>
                        <span>
                            مالیات
                        </span>
                        <span>
                            {Helpers.Utils.formatPrice(this.getGst())}
                        </span>
                    </div>

                    <div style={{
                        display: this.getInstallmentState() ? 'flex' : 'none'
                    }}
                         className='order-summary-item'>
                        <span>
                            خرید اقساطی
                        </span>
                        <span>
                            {Helpers.Utils.formatPrice(this.state.installmentAmount)}
                        </span>
                    </div>

                    <div className='order-summary-item'>
                        <span>
                            هزینه ارسال و بسته بندی
                        </span>
                        <span>
                            {this.getDeliveryCostStr(this.state.deliveryCost)}
                        </span>
                    </div>

                    <hr className='order-summary-separator' />

                    <div className='order-final-total-container'>
                        <div>
                            قابل پرداخت:
                        </div>
                        <span>
                            {Helpers.Utils.formatPrice(finalAmount)}
                        </span>
                    </div>

                    <div className="order-summary-btn-sticky">
                        <button
                            onClick={this.buttonAction}
                            className='btn btn-aqua order-summary-continue-button'>
                            <i className='fa fa-lg fa-arrow-circle-left fa-2x text-top ml5'></i>
                            {this.props.buttonText}
                        </button>
                    </div>

                    
                </div>
                <div className='row no-gutters order-summary-message'>
                    <p className="text-fa-h6">
                    <i className='fa fa-exclamation-circle fa-lg'></i>
                        کالاهای موجود در سبد خرید شما ثبت و رزرو نشده‌اند،
                        برای ثبت سفارش مراحل بعدی را تکمیل کنید.
                    </p>
                </div>
                <div className='alert alert-danger text-fa-h6  text-right pr-2 rtl error-line-height'
                    style={{ display: this.state.errors && this.state.errors.length > 0 ? 'block' : 'none' }}
                    dangerouslySetInnerHTML={{__html: this.state.errors && this.state.errors.join('<br />')}}>
                </div>
            </div>
        );
    }

    private buttonAction = e => {
        orderSummaryHelper.buttonAction();
        e.preventDefault();
    }

    private getInitialState = (): State => ({
        cartTotal: null,
        cartDiscount: null,
        creditDiscount: null,
        gstRate: null,
        deliveryCost: null,
        voucherDiscount: null,
        installmentAmount: null,
        isOfficialInvoice: null,
        errors: null
    });

    private getFinamAmount = (): number => {
        const taxableAmount = this.getTaxableAmount();
        const gst = this.getGst();

        return taxableAmount + gst + this.getDeliveryCost() - this.getInstallmentAmount();
    }

    private getTaxableAmount = (): number => {
        const taxableAmount =
            this.state.cartTotal -
            this.state.cartDiscount -
            this.state.creditDiscount -
            this.state.voucherDiscount;

        return taxableAmount;
    }

    private getInstallmentAmount = (): number => {
        return this.getInstallmentState() ? this.state.installmentAmount:0;
    }
    private getInstallmentState = (): boolean => {
        return this.state.installmentAmount &&
            this.state.installmentAmount > 0;
    }

    private getGst = (): number => {
        const multiplier = this.state.isOfficialInvoice ? 1 : 0;
        const gstRate = multiplier * this.state.gstRate;
        const taxableAmount = this.getTaxableAmount();
        return Math.floor(taxableAmount * gstRate * 0.01);
    }

    private getDeliveryCost = (shippingCost?: number): number => {
        const multiplier = this.state.isOfficialInvoice ? 1 : 0;
        const gstRate = multiplier * this.state.gstRate;
        return shippingCost === null ? null : Math.floor(this.state.deliveryCost * (1 + (gstRate * 0.01)));
    }

    private getDeliveryCostStr = (shippingCost?: number): string => {
        const amount = this.getDeliveryCost(shippingCost);
        return amount === null ? 'وابسته به آدرس' : Helpers.Utils.formatPrice(amount);
    }

    private setDeliveryCost = (deliveryCost: number) => {
        this.setState({
            deliveryCost
        });
    }

    private setOfficialInvoice = (value: boolean) => {
        this.setState({
            isOfficialInvoice: value
        });
    }

    private setCartTotal = (cartTotal: number, cartDiscount: number) => {
        this.setState({
            cartTotal,
            cartDiscount
        });
    }

    private setErrors = (errors: string[]) => {
        this.setState({
            errors
        });
    }

    private setVoucherDiscount = (voucherDiscount: number) => {
        this.setState({
            voucherDiscount
        });
    }

    private setInstallmentAmount = (installmentAmount: number) => {
        this.setState({
            installmentAmount
        });
    }
}

Helpers.ReactHelper.createReactElement('OrderSummary', OrderSummary);

export default orderSummaryHelper;
